import { render, staticRenderFns } from "./ModalInventoryType.vue?vue&type=template&id=ba0af4be&"
import script from "./ModalInventoryType.vue?vue&type=script&lang=js&"
export * from "./ModalInventoryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports